import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { SettingsEditState } from '@ops/services';
import { OpsTeamMemberComponent } from './ops-team-member.component';
import { OpsInviteMemberComponent } from '../ops-invite-member/ops-invite-member.component';
import { OpsSelectComponent } from '../ops-select/ops-select.component';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    OpsInviteMemberComponent,
    OpsSelectComponent,
    NgxsModule.forRoot([SettingsEditState]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    TranslateModule,
  ],
  declarations: [OpsTeamMemberComponent],
  exports: [OpsTeamMemberComponent],
})
export class OpsTeamMemberModule {}
